import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const stored = localStorage.getItem("softstrides-cart");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem(
      "softstrides-cart",
      JSON.stringify(cartItems)
    );
  }, [cartItems]);

  /* ==============================
     ADD TO CART (SIZE SUPPORTED)
  ============================== */
  const addToCart = (product) => {
    if (!product.size) {
      alert("Size is required");
      return;
    }

    setCartItems((prev) => {
      // 🔥 check BOTH id + size
      const exists = prev.find(
        (item) =>
          item._id === product._id &&
          item.size === product.size
      );

      if (exists) {
        return prev.map((item) =>
          item._id === product._id &&
          item.size === product.size
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      }

      return [...prev, { ...product, qty: 1 }];
    });
  };

  /* ==============================
     INCREASE QTY (ID + SIZE)
  ============================== */
  const increaseQty = (id, size, index) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item._id === id && item.size === size && item.index === index
          ? { ...item, qty: item.qty + 1 }
          : item
      )
    );
  };

  /* ==============================
     DECREASE QTY (ID + SIZE)
  ============================== */
  const decreaseQty = (id, size, index) => {
    setCartItems((prev) =>
      prev
        .map((item) =>
          item._id === id && item.size === size && item.index === index
            ? { ...item, qty: item.qty - 1 }
            : item
        )
        .filter((item) => item.qty > 0)
    );
  };

  /* ==============================
     REMOVE ITEM (ID + SIZE)
  ============================== */
  const removeItem = (id, size, index) => {
    setCartItems((prev) =>
      prev.filter(
        (item) =>
          !(item._id === id && item.size === size && item.index === index)
      )
    );
  };

const clearCart = () => {
  setCartItems([]);
};
  /* ==============================
     TOTAL PRICE
  ============================== */
const subtotal = cartItems.reduce(
  (acc, item) =>
    acc +
    Number(item.discountPrice || 0) *
    Number(item.qty || 1),
  0
);

const shippingCharge =
  subtotal >= 999 ? 0 : 59;

const totalPrice =
  subtotal + shippingCharge;

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        increaseQty,
        decreaseQty,
        removeItem,
        totalPrice,
        shippingCharge,
        subtotal,
        clearCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);